import axiosInstance from "../utils/axiosInstance";
import { telemetryClient } from "../../services/telemetryClient";

const ENDPOINT = "/qa-assist/create";

interface CreateQaAssistResponse {
  message: string;
  jobId: string;
}

interface CreateQaAssistOptions {
  questionsText?: string;
  answersText?: string;
  additionalContext?: string;
  filePasswords?: Record<string, string>;
  enableDocumentChat?: boolean;
}

export const createQaAssist = async (
  questionsFiles: string[],
  answersFiles: string[],
  options: CreateQaAssistOptions = {},
): Promise<CreateQaAssistResponse> => {
  const startedAt = Date.now();
  telemetryClient.log("job.createRequest.start", { metadata: { endpoint: ENDPOINT } });
  try {
    const response = await axiosInstance.post<CreateQaAssistResponse>(
      ENDPOINT,
      {
        ...(questionsFiles.length > 0 ? { questionsFiles } : {}),
        ...(answersFiles.length > 0 ? { answersFiles } : {}),
        ...(options.questionsText?.trim() ? { questionsText: options.questionsText.trim() } : {}),
        ...(options.answersText?.trim() ? { answersText: options.answersText.trim() } : {}),
        ...(options.additionalContext?.trim()
          ? { additionalContext: options.additionalContext.trim() }
          : {}),
        ...(options.filePasswords && Object.keys(options.filePasswords).length > 0
          ? { filePasswords: options.filePasswords }
          : {}),
        enableDocumentChat: !!options.enableDocumentChat,
      },
    );

    telemetryClient.log("job.createRequest.success", {
      jobId: response.data.jobId,
      metadata: { endpoint: ENDPOINT, durationMs: Date.now() - startedAt },
    });
    return response.data;
  } catch (error: any) {
    telemetryClient.log("job.createRequest.error", {
      level: "error",
      metadata: {
        endpoint: ENDPOINT,
        durationMs: Date.now() - startedAt,
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
      },
    });
    throw new Error(error.response?.data?.message || "Failed to create Q&A assist.");
  }
};
